import React, {Fragment, useState} from "react";

import HookSubFormChildDetails from "root/Base/HookFormComponents/HookSubFormChildDetails";
import {SaveButton} from "root/Modals/SaveButton";
import {useForm} from "react-hook-form";
import {childHeader} from "root/Base/HookFormComponents/childDataFormHelpers";
import {fuzzyChildSearch} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import ExistingChildTable from "./ExistingChildTable";

import useModalReinstateChild from "root/Modals/ModalReinstateChild/useModalReinstateChild";
import {ModalReinstateModes} from "root/Modals/ModalReinstateChild/ModalReinstateChild";
import {useChildContext} from "root/Contexts/ChildContext";
import {newChildModes} from "root/NewToLAC/CreateChild3";

const NewChildForm = ({notify}) =>
{
    const createStates = {
        SEARCH: 1,
        MATCHES_FOUND: 2,
        NO_MATCHES_FOUND: 3
    }

    const { getChildData } = useChildContext() ;

    const [ renderModal, showReinstateModal ] = useModalReinstateChild( ( result, child_id ) =>
    {
        if ( result !== 'cancel' )
        {
            const mode = newChildModes.RETURNING;

            // Set the system variable with data we want to keep. This will be ignored by the form processor

            getChildData ( child_id ) ;

            notify( {
                fragment: {form: {mode: mode, child_id: child_id}},
                stage: 2 });
        }
    });

    const {reset, resetField, register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ...childHeader(null),
            }
        });

    const [children, setChildren] = useState({isLoading: true, data: []});
    const [createState, setCreateState] = useState(createStates.SEARCH);

    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
    }

    const onSubmit = (data) =>
    {
        console.log(data);

        fuzzyChildSearch(data, (response) =>
        {
            const rval = getDataFromResponse(response);

            if (rval.length === 0)
            {
                setCreateState(createStates.NO_MATCHES_FOUND);
                setChildren({isLoading: false, data: []});
            }
            else
            {
                setCreateState(createStates.MATCHES_FOUND);
                setChildren({isLoading: false, data: rval});
            }

            console.log(rval);
        })
    }

    const onClickSearch = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const onClickSearchAgain = () =>
    {
        setCreateState( createStates.SEARCH );
    }

    const onEnter = ( data ) =>
    {
        // Set the system variable with data we want to keep. This will be ignored by the form processor

        const initialChild = {
            firstname: data.header.firstname,
            middlename: data.header.middlename,
            surname: data.header.surname,
            esw_name: null,
            child_upn: null,
            gender: null,
            date_of_birth: null,
            date_became_lac: null,
            date_last_became_lac: null,
            year_id: null,
        }

        notify( {
            fragment: {form: {mode: newChildModes.NEW, child_id: null}},
            stage: 2,
            initialChild: initialChild
        });
    }

    const onClickEnterDetails = (status) =>
    {
        handleSubmit(onEnter)(status);
    }

    const doReinstate = ( child_id ) =>
    {
        showReinstateModal({ mode: ModalReinstateModes.REINSTATE, child_id: child_id })
    }

    const childList = () =>
    {
        return (
        < ExistingChildTable externalData={true} data={children.data} onChildClick={doReinstate} />
        )
    }

    const pickChildSection = () =>
    {

        return (
            <div className='existing-child-message'>
                <div className='ecm-header'>The pupil details you entered appear to match some existing pupils. </div>
                <div className='ecm-header'>If the pupil seems to be already in the system, you can either select the reinstate icon to return them or, if they are already on the system, please press the cancel button to ensure you do not create duplicates.</div>
                <div className='ecm-detail'>To reinstate one of these pupils, please select the icon or, if you cannot see any matches, you can click 'Continue to enter details' to finish creating this pupil</div>
                { childList() }
            </div>
        )
    }

    const noChildSection = () =>
    {
        return (
            <div className='existing-child-message'>
                <div className='ecm-header'>There were no existing or ex-CfC pupils meeting these criteria. To continue creating this pupil, click the 'Continue to enter details' button below. </div>
            </div>
        )
    }

    return (
        <Fragment>
        <form className='' onSubmit={handleSubmit(onSubmit)}>

            <HookSubFormChildDetails key='childDetailForm' readOnly={createState !== createStates.SEARCH} search={true} {...controlProps} sectionName='header' isPost16={false}/>

            {createState === createStates.MATCHES_FOUND && pickChildSection()}
            {createState === createStates.NO_MATCHES_FOUND && noChildSection()}

            <div className="button-row top-margin">
                { createState === createStates.SEARCH && <SaveButton disabled={false} onClick={onClickSearch} kay={'sb'}>Search Pupil</SaveButton> }
                { createState === createStates.MATCHES_FOUND && <SaveButton disabled={false} onClick={onClickSearchAgain} kay={'sb'}>Search Again</SaveButton> }
                { ( createState === createStates.NO_MATCHES_FOUND || createState === createStates.MATCHES_FOUND ) && <SaveButton disabled={false} onClick={onClickEnterDetails} kay={'sb'}>Continue to Enter Pupil Details</SaveButton> }
            </div>
        </form>
            { renderModal() }
        </Fragment>
    )

}

export default NewChildForm;